import { SVGProps, Ref, forwardRef } from 'react';

export const HrBrandOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M5.637 22A7.06 7.06 0 0 1 12 17.987 7.06 7.06 0 0 1 18.363 22z" fill="currentColor" />
        <path d="M23 9.338a7.07 7.07 0 0 0-5.769 4.834 7.1 7.1 0 0 0 1.837 7.314z" fill="currentColor" />
        <path d="M4.932 21.487a7.1 7.1 0 0 0 1.837-7.314A7.07 7.07 0 0 0 1 9.339z" fill="currentColor" />
        <path d="M12.436 1a7.1 7.1 0 0 0 2.799 7 7.04 7.04 0 0 0 7.497.507z" fill="currentColor" />
        <path d="M1.268 8.508A7.04 7.04 0 0 0 8.766 8a7.1 7.1 0 0 0 2.798-7z" fill="currentColor" />
    </svg>
));
HrBrandOutlinedSize24Glyph.displayName = 'HrBrandOutlinedSize24Glyph';
